import { query } from "./strapi";

export async function getBlogHome() {
  const res = await query("blog-home");
  return res;
}
